/**
 * Tool Display 消息处理器
 */
import { mapRawToSearchDocs } from '../../mappers';
import { replaceStreamingIdWithReal } from '../message-updater';
import type { StreamMessageHandler, StreamMessageData, HandlerContext } from '../types';

/**
 * Tool Display 消息处理器
 * 处理 business_type='tool_display' 的消息，展示右侧面板
 */
export const toolDisplayHandler: StreamMessageHandler = {
  name: 'tool-display',

  canHandle(data: StreamMessageData): boolean {
    return data.business_type === 'tool_display';
  },

  handle(data: StreamMessageData, ctx: HandlerContext): boolean {
    const { tool_key, streaming_content, tool_state, meta, content, id } = data;
    const rawContent =
      content && typeof content === 'object' && !Array.isArray(content) && 'raw' in content
        ? (content as { raw?: unknown }).raw
        : content;

    // Handle search_json_docs-specific behavior.
    if (tool_key === 'search_json_docs' && Array.isArray(rawContent)) {
      ctx.streamContext.deps.searchDocsList.value = mapRawToSearchDocs(rawContent);
    }

    const streamingId = ctx.messageUpdater.updateStreamingToolDisplay(
      tool_key,
      streaming_content ?? '',
      tool_state,
      meta,
      content,
    );

    if (tool_state === 'completed' && id && streamingId !== undefined) {
      const { conversationData, selectedAgentMessageId } = ctx.streamContext.deps;
      replaceStreamingIdWithReal(conversationData, selectedAgentMessageId, streamingId, id);
    }

    // Streaming search results are provisional and may not use the user's language.
    // Once the result has a persisted id, refresh the localized source registry instead
    // of waiting for the whole pipeline to reach stop_flag.
    if (tool_key === 'search_json_docs' && tool_state === 'completed' && id) {
      ctx.streamContext.deps
        .fetchAllSearchSources(ctx.streamContext.streamIteration, { force: true })
        .catch(() => undefined);
    }

    if (tool_key === 'extract_summary' && tool_state === 'completed') {
      const { conversationData, tryAutoOpenLastToolResult } = ctx.streamContext.deps;
      const tableCompleted = (conversationData.value ?? []).some(
        (message) =>
          message.iteration === ctx.streamContext.streamIteration &&
          message.tool_key === 'extract_table_maker_json_docs' &&
          message.tool_state === 'completed',
      );
      if (tableCompleted) tryAutoOpenLastToolResult(conversationData.value);
    }

    // tool_display completed 时不再结束流，等待 SSE 连接关闭
    return false;
  },
};
